import services from '@/services/ascentiaServiceIndex'
import {
  buildSimpleAlertJson,
  parseSimpleAlertJson,
  buildAdvancedAlertJson,
  parseAdvancedAlertJson,
  isCustomAlertTypeIncludes,
} from '../../utilities/customAlerts'
import { CUSTOM_ALERT_CONSTS as CAC } from '../consts'
import {
  CUSTOM_ALERT_SNAPSHOT_DATA_ID,
  ADVANCED_CUSTOM_ALERTS,
} from '@/utilities/appConsts'
import moment from 'moment'

const state = {
  startDate: moment().subtract(6, 'months').format('MM-DD-YYYY'),
  endDate: moment().format('MM-DD-YYYY'),
  dataBricksResponse: null,
  customAlerts: [],
  customAlert: {
    ruleDefinitionJson: {},
    customAlertId: null,
    runId: 0,
    lookbackLimit :{
      runCount:0,
      runLimit:0,
    }
  },
  customAlertTypes: [],
  sharedAnalyticsForAirline: [],
  editAlert: null,
  parameterList: [],
  parameterTailList: [],
  logicBuilderGuide: new Blob(),
  customAlertFunctionList: [],
  activeNotificationsState: [],
  partNumbers: [],
}

const getters = {
  parameterList(state, getters, rootState, rootGetters) {
    return state.parameterList.filter(item => {
      // Global Airline Filter
      if (rootGetters['globalFilter/showAllAirlines']) {
        return true
      } else {
        return (
          rootGetters['globalFilter/airlineIdsSelected'].indexOf(
            item.airlineId,
          ) > -1
        )
      }
    })
  },
}

const mutations = {
  [CAC.UPDATE_CUSTOM_ALERTS]: (state, data) => (state.customAlerts = data),
  [CAC.UPDATE_SHARED_CUSTOM_ALERTS]: (state, data) =>
    (state.sharedAnalyticsForAirline = data),
  [CAC.APPEND_CUSTOM_ALERT]: (state, data) => state.customAlerts.push(data),
  [CAC.SET_CUSTOM_ALERT_TYPES]: (state, data) =>
    (state.customAlertTypes = data),
  [CAC.UPDATE_CUSTOM_ALERT_DATABRICKS_RUNID]: (state, data) => {
    state.customAlert.runId = data
  },
  [CAC.UPDATE_CUSTOM_ANALYTIC_RUN_COUNT]: (state, data) => {
    state.customAlert.lookbackLimit = {...state.customAlert.lookbackLimit,...data}
  },
  [CAC.UPDATE_DATABRICKS_RESPONSE]: (state, data) => {
    state.dataBricksResponse = data
  },

  [CAC.UPDATE_CUSTOM_ALERT]: (state, data) => {
    const updatedAlert = { ...state.customAlert, ...data }
    state.customAlert = updatedAlert
    state.customAlerts = state.customAlerts.map(alertObj => {
      if (
        alertObj.baseAlertId === updatedAlert.id ||
        alertObj.name === updatedAlert.name
      ) {
        return {
          ...alertObj,
          ...updatedAlert,
        }
      } else {
        return alertObj
      }
    })
  },
  [CAC.UPDATE_PARAMETER_LIST]: (state, data) => (state.parameterList = data),
  [CAC.UPDATE_PARAMETER_TAIL_LIST]: (state, data) =>
    (state.parameterTailList = data),
  [CAC.UPDATE_ADVANCED_ALERT_TAIL_LIST]: (state, data) =>
    (state.parameterTailList = data),
  [CAC.UPDATE_CUSTOM_ALERT_FUNCTIONS]: (state, data) => {
    state.customAlertFunctionList = data
    state.customAlert = {
      ...state.customAlert,
      advancedFunction: data,
    }
  },
  [CAC.SET_CURRENT_ALERT]: (state, data) => {
    // need to parse custom alert JSON to get data out
    state.customAlert.runId = data.runId
    state.customAlert.customAlertId = data.id
    state.customAlert.id = data.baseAlertId
    state.customAlert.name = data.name
    state.customAlert.analyticDescription = data.analyticDescription
    state.customAlert.createdBy = data.createdBy
    state.customAlert.acmfReportNumberId = data.acmfReportNumberId
      ? data.acmfReportNumberId
      : null
    state.customAlert.customAlertTypeId = data.customAlertTypeId
    state.customAlert.airlineId = data.airlineId
    state.customAlert.platformId = data.masterModelId
      ? data.masterModelId
      : null
    state.customAlert.isEnabled = data.isEnabled
    state.customAlert.tails = data.aircraftIds
    state.customAlert.ataChapters = data.ataChapters
    state.customAlert.recAction = data.recAction
    state.customAlert.isShared = data.isShared
    state.customAlert.resetPerformanceValues = data.resetPerformanceValues
    state.customAlert.continuedVersionHistoryPerformance =
      data.continuedVersionHistoryPerformance
    state.customAlert.performanceSetDate = data.performanceSetDate
    state.customAlert.guid = data.guid
    state.customAlert.userId = data.userId
    const parsedRules = isCustomAlertTypeIncludes(
      'Advanced',
      state.customAlert.customAlertTypeId,
      state.customAlertTypes,
    )
      ? parseAdvancedAlertJson(data.ruleDefinitionJson)
      : parseSimpleAlertJson(data.ruleDefinitionJson)
    state.customAlert = {
      ...state.customAlert,
      ...parsedRules,
      persistenceFrom:
        parsedRules.persistenceFrom === '' ? 1 : parsedRules.persistenceFrom,
      persistenceTo:
        parsedRules.persistenceTo === '' ? 1 : parsedRules.persistenceTo,
    }
    state.customAlert.partNumbers = data.partNumberIds
    state.customAlert.lookbackLimit = data.lookbackLimit
  },
  [CAC.RESET_CUSTOM_ALERT]: state => {
    state.customAlert = {
      ruleDefinitionJson: {},
      customAlertId: null,
      runId: 0,
      lookbackLimit :{
        runCount:0,
        runLimit:0,
      }
    }
    state.editAlert = null
    state.parameterList = []
    state.parameterTailList = []
  },
  [CAC.UPDATE_CUSTOM_ALERT_LOGIC_BUILDER_GUIDE]: (state, data) =>
    (state.logicBuilderGuide = data),
  [CAC.UPDATE_ACTIVATION_NOTIFICATIONS]: (state, data) =>
    (state.activeNotificationsState = data),
  [CAC.SET_PART_NUMBERS]: (state, data) => (state.partNumbers = data),
}

const actions = {
  async [CAC.GET_CUSTOM_ALERTS](
    { commit, rootState },
    args = { refresh: true },
  ) {
    // Clear all previously saved data as
    // Aggrid is not reactiveif the API returns same
    // and filters are not updating in customalerts grid
    commit(CAC.UPDATE_CUSTOM_ALERTS, [])

    const response = await services.customalert.getData(
      'customAlerts',
      null,
      args.refresh,
    )
    const alertsWithAirlineName = response.data.map(alertObj => {
      const airlineName = rootState.user.airlines.filter(airlineObj => {
        return airlineObj.id === alertObj.airlineId
      })
      // For each custom alert, depending on their custom alert type, choose the correct rules definition parser
      const parsedAlertJson = ADVANCED_CUSTOM_ALERTS.find(
        item => item.id === alertObj.customAlertTypeId,
      )
        ? parseAdvancedAlertJson(alertObj.ruleDefinitionJson)
        : parseSimpleAlertJson(alertObj.ruleDefinitionJson)

      return {
        ...alertObj,
        airline: airlineName.length ? airlineName[0].name : '',
        ...parsedAlertJson,
      }
    })

    const alertsWithModelNames = await Promise.all(
      alertsWithAirlineName.map(alertObj => {
        // if the alert doesn't have a parameter set we can't get the airline/model info
        // so just return N/A for it so we don't get API errors
        if (alertObj.parameterId === null) {
          return {
            ...alertObj,
            model: 'N/A',
            airline: 'N/A',
          }
        }
        if (
          ADVANCED_CUSTOM_ALERTS.find(
            item => item.id === alertObj.customAlertTypeId,
          )
        ) {
          let platformName = ''
          const lookupPlatform = rootState.lookups.masterModels.filter(
            value => value.masterModelId === alertObj.masterModelId,
          )
          if (lookupPlatform.length > 0) {
            platformName = lookupPlatform[0].text
          } else {
            const acmfPlatform =
              rootState.acmfReportList.masterModelsData.filter(
                value => value.id == alertObj.masterModelId,
              )
            platformName = acmfPlatform.length ? acmfPlatform[0].name : ''
          }
          return {
            ...alertObj,
            model: platformName,
          }
        }
        if (alertObj.customAlertTypeId === CUSTOM_ALERT_SNAPSHOT_DATA_ID) {
          return services.customalert
            .getData(
              'snapshotMasterModelByParameter',
              {
                parameterId: alertObj.parameterId,
                airlineId: alertObj.airlineId,
              },
              true,
            )
            .then(res => {
              return {
                ...alertObj,
                model: res.data.masterModelName
                  ? res.data.masterModelName
                  : 'N/A',
              }
            })
            .catch(() => {
              return Promise.resolve({
                ...alertObj,
                model: 'N/A',
                airline: 'N/A',
              })
            })
        } else {
          return services.customalert
            .getData(
              'masterModelByParameter',
              {
                parameterId: alertObj.parameterId,
                airlineId: alertObj.airlineId,
              },
              true,
            )
            .then(res => {
              return {
                ...alertObj,
                model: res.data.masterModelName
                  ? res.data.masterModelName
                  : 'N/A',
              }
            })
            .catch(() => {
              return Promise.resolve({
                ...alertObj,
                model: 'N/A',
                airline: 'N/A',
              })
            })
        }
      }),
    )

    const filteredAlerts = alertsWithModelNames
    commit(CAC.UPDATE_CUSTOM_ALERTS, filteredAlerts)
  },

  async [CAC.GET_SHARED_ALERTS_FOR_AIRLINE](
    { commit, rootState },
    userAirlineIds,
  ) {
    // Clear all previously saved data as
    // Aggrid is not reactiveif the API returns same
    // and filters are not updating in customalerts grid
    commit(CAC.UPDATE_SHARED_CUSTOM_ALERTS, [])

    const response = await services.customalert.getData(
      'sharedAnalyticsForAirline',
      userAirlineIds,
      true,
    )
    const alertsWithAirlineName = response.data.map(alertObj => {
      const airlineName = rootState.user.airlines.filter(airlineObj => {
        return airlineObj.id === alertObj.airlineId
      })
      // For each custom alert, depending on their custom alert type, choose the correct rules definition parser
      const parsedAlertJson = ADVANCED_CUSTOM_ALERTS.find(
        item => item.id === alertObj.customAlertTypeId,
      )
        ? parseAdvancedAlertJson(alertObj.ruleDefinitionJson)
        : parseSimpleAlertJson(alertObj.ruleDefinitionJson)

      return {
        ...alertObj,
        airline: airlineName.length ? airlineName[0].name : '',
        ...parsedAlertJson,
      }
    })

    const alertsWithModelNames = await Promise.all(
      alertsWithAirlineName.map(alertObj => {
        // if the alert doesn't have a parameter set we can't get the airline/model info
        // so just return N/A for it so we don't get API errors
        if (alertObj.parameterId === null) {
          return {
            ...alertObj,
            model: 'N/A',
            airline: 'N/A',
          }
        }
        if (
          ADVANCED_CUSTOM_ALERTS.find(
            item => item.id === alertObj.customAlertTypeId,
          )
        ) {
          let platformName = ''
          const lookupPlatform = rootState.lookups.masterModels.filter(
            value => value.masterModelId === alertObj.masterModelId,
          )
          if (lookupPlatform.length > 0) {
            platformName = lookupPlatform[0].text
          } else {
            const acmfPlatform =
              rootState.acmfReportList.masterModelsData.filter(
                value => value.id == alertObj.masterModelId,
              )
            platformName = acmfPlatform.length ? acmfPlatform[0].name : ''
          }
          return {
            ...alertObj,
            model: platformName,
          }
        }
        if (alertObj.customAlertTypeId === CUSTOM_ALERT_SNAPSHOT_DATA_ID) {
          return services.customalert
            .getData(
              'snapshotMasterModelByParameter',
              {
                parameterId: alertObj.parameterId,
                airlineId: alertObj.airlineId,
              },
              true,
            )
            .then(res => {
              return {
                ...alertObj,
                model: res.data.masterModelName
                  ? res.data.masterModelName
                  : 'N/A',
              }
            })
            .catch(() => {
              return Promise.resolve({
                ...alertObj,
                model: 'N/A',
                airline: 'N/A',
              })
            })
        } else {
          return services.customalert
            .getData(
              'masterModelByParameter',
              {
                parameterId: alertObj.parameterId,
                airlineId: alertObj.airlineId,
              },
              true,
            )
            .then(res => {
              return {
                ...alertObj,
                model: res.data.masterModelName
                  ? res.data.masterModelName
                  : 'N/A',
              }
            })
            .catch(() => {
              return Promise.resolve({
                ...alertObj,
                model: 'N/A',
                airline: 'N/A',
              })
            })
        }
      }),
    )

    const filteredAlerts = alertsWithModelNames
    commit(CAC.UPDATE_SHARED_CUSTOM_ALERTS, filteredAlerts)
  },

  async [CAC.GET_CUSTOM_ALERT_FUNCTIONS]({ commit }, alertTypeId) {
    const response = await services.customalert.getData(
      'customAlertAdvancedFunctions',
      alertTypeId,
      true,
    )
    commit(CAC.UPDATE_CUSTOM_ALERT_FUNCTIONS, response.data)
  },
  async [CAC.GET_CUSTOM_ALERT]({ commit }, alertId) {
    const response = await services.customalert.getData(
      'customAlert',
      alertId,
      true,
    )
    commit(CAC.SET_CURRENT_ALERT, response.data)
  },
  async [CAC.GET_CUSTOM_ALERT_TYPES]({ commit }) {
    const response = await services.customalert.getData(
      'customAlertTypes',
      true,
    )
    commit(CAC.SET_CUSTOM_ALERT_TYPES, response.data)
  },
  async [CAC.SAVE_CUSTOM_ALERT]({ commit, state }) {
    // build the json object from the rule data
    const typeId = state.customAlert.customAlertTypeId
    const isACMF = isCustomAlertTypeIncludes(
      'ACMF',
      typeId,
      state.customAlertTypes,
    )
    const isAdvanced = isCustomAlertTypeIncludes(
      'Advanced',
      typeId,
      state.customAlertTypes,
    )
    const ruleToSave = {
      id: state.customAlert?.id,
      name: state.customAlert.name,
      analyticDescription: state.customAlert.analyticDescription,
      acmfReportNumberId:
        // state.customAlert.customAlertTypeId === CUSTOM_ALERT_SNAPSHOT_DATA_ID ||
        isACMF ? state.customAlert?.acmfReportNumberId : null,
      customAlertTypeId: state.customAlert.customAlertTypeId,
      airlineId: state.customAlert.airlineId,
      masterModelId: state.customAlert.platformId,
      isEnabled: state.customAlert.isEnabled,
      ataChapters: state.customAlert.ataChapters,
      recAction: state.customAlert.recAction,
      isShared: state.customAlert.isShared,
      ruleDefinitionJson: isAdvanced
        ? buildAdvancedAlertJson(state.customAlert)
        : buildSimpleAlertJson(state.customAlert),
      aircraftIds:
        state.customAlert.tails !== undefined ? state.customAlert.tails : [],
      partNumberIds:
        state.customAlert.partNumbers !== undefined
          ? state.customAlert.partNumbers
          : [],
      resetPerformanceValues: state.customAlert.resetPerformanceValues,
    }
    const response = await services.customalert.saveData(
      'customAlert',
      ruleToSave,
    )
    if (response.status === 201 && ruleToSave.id === null) {
      // if this is a new alert, push it onto the stack of custom alerts
      const parsedLocationResponse = response.headers.location.split('/')
      commit(CAC.APPEND_CUSTOM_ALERT, ruleToSave)
      commit(CAC.UPDATE_CUSTOM_ALERT, {
        id: parsedLocationResponse[parsedLocationResponse.length - 1],
      })
    }
  },
  // eslint-disable-next-line no-unused-vars
  async [CAC.DELETE_CUSTOM_ALERT]({ commit }, idsToDelete) {
    await services.customalert.deleteData('customAlert', idsToDelete, true)
  },
  async [CAC.GET_FULLFLIGHT_PARAMETER_LIST]({ commit }, fullFlightData) {
    const response = await services.customalert.getData(
      'fullFlightParameterList',
      {
        airlineIds: fullFlightData.airlineIds,
        platformId: fullFlightData.platformId,
      },
      { refresh: true },
    )
    commit(CAC.UPDATE_PARAMETER_LIST, response.data)
  },
  async [CAC.GET_SNAPSHOT_PARAMETER_LIST]({ commit }, data) {
    const response = await services.customalert.getData(
      'snapshotParameterList',
      data,
      { refresh: true },
    )
    commit(CAC.UPDATE_PARAMETER_LIST, response.data)
  },
  [CAC.UPDATE_CUSTOM_ALERT]({ commit }, alertData) {
    commit(CAC.UPDATE_CUSTOM_ALERT, alertData)
  },
  [CAC.UPDATE_ACTIVATION_NOTIFICATIONS]({ commit }, activateNotificationData) {
    commit(CAC.UPDATE_ACTIVATION_NOTIFICATIONS, activateNotificationData)
  },
  async [CAC.TOGGLE_ALERT]({ dispatch }, alert) {
    await services.customalert.saveData('customAlert', alert)
    await dispatch(CAC.GET_CUSTOM_ALERTS, { refresh: true })
  },
  async [CAC.GET_ADVANCED_ALERT_TAIL_LIST]({ commit }, alertInfo) {
    let tailList = []
    if (alertInfo.alertType === 'advanced-acmf') {
      tailList = await services.customalert.getData(
        'advancedSnapshotTailList',
        {
          airlineId: alertInfo.airlineId,
          acmfReportNumberId: alertInfo.reportNumber,
        },
        true,
      )
    } else {
      tailList = alertInfo.tailsByPlatformAndAirline
    }
    if (
      tailList.data &&
      tailList.data.length &&
      alertInfo.alertType === 'advanced-acmf'
    ) {
      const tailListOptions = tailList.data.map(aircraftObj => {
        return {
          value: aircraftObj.id,
          text: aircraftObj.tailNumber,
        }
      })
      commit(CAC.UPDATE_ADVANCED_ALERT_TAIL_LIST, tailListOptions)
    } else if (tailList && tailList.length) {
      const tailListOptions = tailList.map(aircraftObj => {
        return {
          value: aircraftObj.value,
          text: aircraftObj.text,
        }
      })
      commit(CAC.UPDATE_ADVANCED_ALERT_TAIL_LIST, tailListOptions)
    } else {
      commit(CAC.UPDATE_ADVANCED_ALERT_TAIL_LIST, [])
    }
  },
  async [CAC.GET_PARAMETER_TAIL_LIST]({ commit }, alertInfo) {
    let tailList = []
    if (alertInfo.alertType === 'acmf') {
      tailList = await services.customalert.getData(
        'snapshotTailList',
        {
          parameterId: alertInfo.parameterId,
          airlineId: alertInfo.airlineId,
          acmfReportNumberId: alertInfo.reportNumberId,
        },
        true,
      )
    } else {
      tailList = await services.customalert.getData(
        'fullFlightTailList',
        {
          parameterId: alertInfo.parameterId,
          airlineId: alertInfo.airlineId,
        },
        true,
      )
      // update the parameter unit name for cpl alerts
      commit(CAC.UPDATE_CUSTOM_ALERT, {
        parameterUnitName: tailList.data.units,
      })
    }
    if (tailList.data.aircraft && tailList.data.aircraft.length) {
      const tailListOptions = tailList.data.aircraft.map(aircraftObj => {
        return {
          value: aircraftObj.id,
          text: aircraftObj.tailNumber,
          masterModelId: tailList.data.masterModelId,
        }
      })
      commit(CAC.UPDATE_PARAMETER_TAIL_LIST, tailListOptions)
    } else {
      commit(CAC.UPDATE_PARAMETER_TAIL_LIST, [])
    }
    // get the parameter name back
    if (alertInfo.alertType === 'acmf' && alertInfo.reportNumberId !== null) {
      const parameterName = await services.customalert.getData(
        'snapshotParameterList',
        {
          parameterId: alertInfo.parameterId,
          airlineId: alertInfo.airlineId,
          reportType: alertInfo.reportNumberId,
        },
        true,
      )
      // make additional call to get the ACMF parameter unit name
      commit(CAC.UPDATE_CUSTOM_ALERT, {
        parameterUnitName: parameterName.data[0].unit,
      })
    }
  },
  async [CAC.GET_HISTOGRAM_DATA]({ commit }, alertInfo) {
    let histogramData
    if (alertInfo.alertType === 'acmf') {
      // need to get parameter unit here

      histogramData = await services.customalert
        .getData('acmfHistogramData', alertInfo, { refresh: true })
        .then(res => {
          const updatedData = res.data.map(dataObj => {
            const updatedObj = { ...dataObj }
            if (updatedObj.min.toString().indexOf('e') > 0) {
              updatedObj.min = 0
            }
            if (updatedObj.max.toString().indexOf('e') > 0) {
              updatedObj.max = 0
            }
            return updatedObj
          })
          return updatedData
        })
        .catch(err => {
          return {
            error: err,
          }
        })
    } else {
      // get icao code for airline
      const whichAirline = this.state.user.airlines.filter(airlineObj => {
        return airlineObj.id === alertInfo.airlineId
      })
      alertInfo = {
        ...alertInfo,
        airlineICAOCode:
          whichAirline.length > 0 ? whichAirline[0].icaoCode : null,
      }
      histogramData = await services.customalert
        .getData('cplHistogramData', alertInfo, { refresh: true })
        .then(res => {
          if (res.data.fleet.histograms.length === 0) {
            return []
          } else {
            return res.data.fleet.histograms
          }
        })
        .catch(err => {
          return {
            error: err,
          }
        })
    }
    commit(CAC.UPDATE_CUSTOM_ALERT, {
      histogramData: histogramData,
    })
  },
  async [CAC.DUPLICATE_CURRENT_ALERT]({ commit, dispatch }) {
    // save the current alert first in case there are any unsaved changes
    await dispatch(CAC.SAVE_CUSTOM_ALERT)
    const duplicateAlertToSave = {
      id: null,
      name: `${state.customAlert.name} (copy)`,
      customAlertTypeId: state.customAlert.customAlertTypeId,
      airlineId: state.customAlert.airlineId,
      isEnabled: false,
      ruleDefinitionJson: buildSimpleAlertJson(state.customAlert),
      aircraftIds:
        state.customAlert.tails !== undefined ? state.customAlert.tails : [],
      acmfReportNumberId:
        state.customAlert.customAlertTypeId === CUSTOM_ALERT_SNAPSHOT_DATA_ID
          ? state.customAlert?.acmfReportNumberId
          : null,
    }

    // save the NEW alert
    await services.customalert
      .saveData('customAlert', duplicateAlertToSave)
      .then(res => {
        if (res.status === 201) {
          // if this is a new alert, push it onto the stack of custom alerts
          const parsedLocationResponse = res.headers.location.split('/')
          dispatch(CAC.RESET_CURRENT_CUSTOM_ALERT)
          commit(CAC.APPEND_CUSTOM_ALERT, duplicateAlertToSave)
          commit(CAC.UPDATE_CUSTOM_ALERT, {
            customAlertTypeId: duplicateAlertToSave.customAlertTypeId,
            id: parsedLocationResponse[parsedLocationResponse.length - 1],
          })
        }
        // commit(CAC.UPDATE_CUSTOM_ALERT, res.data)
        // // append the duplicated alert to the array of current alerts
        // commit(CAC.APPEND_CUSTOM_ALERT, res.data)
      })
      .catch(error => console.error('error' + error))
  },
  [CAC.RESET_CURRENT_CUSTOM_ALERT]({ commit }) {
    commit(CAC.RESET_CUSTOM_ALERT)
  },
  async [CAC.GET_CUSTOM_ALERT_LOGIC_BUILDER_GUIDE]({ commit }, alertType) {
    try {
      const response = await services.blobTransfer.getData(
        'logicBuilderGuide',
        alertType,
        true,
      )
      if (response.data) {
        commit(CAC.UPDATE_CUSTOM_ALERT_LOGIC_BUILDER_GUIDE, response.data)
      }
    } catch (error) {
      console.log(`${CAC.GET_CUSTOM_ALERT_LOGIC_BUILDER_GUIDE} error: ${error}`)
    }
  },
  async [CAC.GET_LOGIC_VALIDATION]({ commit }, logicExpression) {
    const validationResult = await services.customalert.getData(
      'customAlertLogicValidation',
      logicExpression,
      true,
    )
    const expressionObj = validationResult.data.isValid
      ? { expression: logicExpression.logicString }
      : {}
    commit(CAC.UPDATE_CUSTOM_ALERT, {
      validLogic: validationResult.data.isValid,
      errorMessage: validationResult.data.errorMessage,
      isLookbackValid: validationResult.data.isLookbackValid,
      ...expressionObj,
    })
  },
  async [CAC.GET_PART_NUMBERS]({ commit }, param) {
    try {
      const response = await services.customalert.getData(
        'partNumbers',
        param,
        true,
      )
      if (response.data) {
        const partNumberOptions = response.data.map(partNumberObj => {
          return {
            value: partNumberObj.id,
            text: partNumberObj.partNumber,
          }
        })
        commit(CAC.SET_PART_NUMBERS, partNumberOptions)
      }
    } catch (error) {
      console.log(`${CAC.GET_CUSTOM_ALERT_LOGIC_BUILDER_GUIDE} error: ${error}`)
    }
  },
  async [CAC.GET_CUSTOM_ALERT_PERFORMANCE]({ commit }) {
    const performanceResult = await services.customalert.getData(
      'customAlertPerformance',
      state.customAlert?.id,
      true,
    )
    commit(CAC.UPDATE_CUSTOM_ALERT, {
      performanceResult: performanceResult.data,
    })
  },
  // eslint-disable-next-line no-unused-vars
  async [CAC.GET_LOOKBACK_STATE_RUNID]({ commit, state }, runId) {
    try {
      const response = await services.customalert.getData(
        'getDataBricksRunIdStatus',
        runId,
        true,
      )
      if(response?.data){
      if(response?.data?.state?.result_state==="SUCCESS"){
        const lookBackRunCountResponse = await services.customalert.getData("getLookbackRunCount",state.customAlert.airlineId,true)
        commit(CAC.UPDATE_CUSTOM_ANALYTIC_RUN_COUNT,lookBackRunCountResponse.data)
      }
        commit(CAC.UPDATE_DATABRICKS_RESPONSE, response?.data)
      }
    } catch (error) {
      console.log(`${CAC.GET_LOOKBACK_STATE_RUNID} error: ${error}`)
      if (error?.message !== CAC.CANCEL_RUNNING_GETSTATUS_LOOKBACK_API) {
        commit(CAC.UPDATE_DATABRICKS_RESPONSE, null)
      }
    }
  },
  async [CAC.GET_LOOKBACK_RUNCOUNT]({commit},airlineId){
    try {
      let response = await services.customalert.getData("getLookbackRunCount",airlineId,true)
      commit(CAC.UPDATE_CUSTOM_ANALYTIC_RUN_COUNT, response.data)

    } catch (error) {
      console.log(`${CAC.GET_LOOKBACK_RUNCOUNT} error: ${error}`)
    }
  },
  async [CAC.TRIGGER_DATABRICKS]({ commit, rootState }) {
    let response = null
    try {
      commit(CAC.UPDATE_DATABRICKS_RESPONSE, null)
      const tails = state.parameterTailList
        .filter(tail => state.customAlert.tails?.indexOf(tail.value) > -1)
        .map(tail => tail.text)
      const partNumbers = state.partNumbers
        .filter(
          partNumber =>
            state.customAlert.partNumbers?.indexOf(partNumber.value) > -1,
        )
        .map(partNumber => partNumber.text)
      const airline = this.state.user.airlines.find(airlineObj => {
        return airlineObj.id === state.customAlert.airlineId
      })
      const platform = rootState.lookups.masterModels.find(mm => {
        return mm.masterModelId === state.customAlert.platformId
      })
      const val = {
        customAlertId: state.customAlert?.customAlertId,
        logicExpression: state.customAlert?.expression,
        persistenceWindow: state.customAlert?.persistenceTo, //persistenceTo
        persistenceCriteria: state.customAlert?.persistenceFrom, //persistenceFrom
        customerIcaoCode: airline.icaoCode,
        platform: platform.text,
        aircraft: tails,
        partNumbers: partNumbers,
        startDate: moment(state.startDate).format('MM-DD-YYYY'),
        endDate: moment(state.endDate).format('MM-DD-YYYY'),
      }

      response = await services.customalert.saveData('dataBricksStatus', val)
      
      if(response?.data){
        commit(CAC.UPDATE_DATABRICKS_RESPONSE, null)
        commit(CAC.UPDATE_CUSTOM_ALERT_DATABRICKS_RUNID, response.data.jobRunId)
        commit(
          CAC.UPDATE_CUSTOM_ANALYTIC_RUN_COUNT,
          {runCount: response.data.lookbackRunCount},
        )
      }
    } catch (error) {
      console.log(`${CAC.TRIGGER_DATABRICKS} error: ${error}`)
      commit(CAC.UPDATE_DATABRICKS_RESPONSE, null)
      commit(CAC.UPDATE_CUSTOM_ALERT_DATABRICKS_RUNID, 0)
    }
  },
  // eslint-disable-next-line no-unused-vars
  async [CAC.CANCEL_LOOKBACK]({ commit }) {
    try {
      await services.customalert.saveData(
        'cancelDataBrick',
        state.customAlert.runId,
      )
      commit(CAC.UPDATE_DATABRICKS_RESPONSE, null)
    } catch (error) {
      console.log(`${CAC.CANCEL_LOOKBACK} error: ${error}`)
    }
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
